import { render, staticRenderFns } from "./ConsultarFolioPantalla.vue?vue&type=template&id=a310443a&"
import script from "./ConsultarFolioPantalla.vue?vue&type=script&lang=ts&"
export * from "./ConsultarFolioPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports